import { render, staticRenderFns } from "./moduleManage.vue?vue&type=template&id=096e9e3c&scoped=true"
import script from "./moduleManage.vue?vue&type=script&lang=js"
export * from "./moduleManage.vue?vue&type=script&lang=js"
import style0 from "./moduleManage.vue?vue&type=style&index=0&id=096e9e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096e9e3c",
  null
  
)

export default component.exports